import React, { PropsWithChildren } from "react";
import styles from "./index.module.scss";

export interface StepContentProps extends PropsWithChildren {}

export const StepContent: React.FC<StepContentProps> = ({ children }) => {
    return <div className={`${styles["step-content"]}`}>{children}</div>;
};
